import { useEffect, useRef } from "react";

const INACTIVITY_TIMEOUT_MS = 2 * 60 * 1000;

export default function useInactivityClose(isOpen, activeLiveContent, closeEPG) {
    const closeEPGRef = useRef(closeEPG);
    closeEPGRef.current = closeEPG;

    useEffect(() => {
        if (!isOpen || !activeLiveContent) return;

        let timerId;

        const resetTimer = () => {
            clearTimeout(timerId);
            timerId = setTimeout(() => closeEPGRef.current(), INACTIVITY_TIMEOUT_MS);
        };

        resetTimer();
        window.addEventListener("keydown", resetTimer, { capture: true });

        return () => {
            clearTimeout(timerId);
            window.removeEventListener("keydown", resetTimer, { capture: true });
        };
    }, [isOpen, activeLiveContent?.id]);
}
